import {io} from "socket.io-client";
import {Env} from "../config";

const useSocket = ({platform = "leap_website"}) => {

    const socket = io(Env.REACT_APP_WEB_SOCKET, {
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        transports: ['websocket'],
        auth: {
            platform: platform
        }
    });

    return {socket}
}

export {useSocket}